import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { LookupService } from "app/webservice/lookup.service";
import { ToastsManager } from "ng2-toastr";
import { Router, Route, ActivatedRoute } from "@angular/router";
import * as $ from 'jquery';
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
  selector: 'app-media-add',
  templateUrl: './media-add.component.html',
  styleUrls: ['./media-add.component.css']
})
export class MediaAddComponent implements OnInit {  
  
  public serviceStackUrl;
  
  public media = {
    AssetCategory: "",
    AssetId: "",
    AssetType: "",
    Description: "",
    Entities:[],
    EventName: "",
    IsDamagedOrLost: false,
    IsMaster: false,
    IsReference: false,
    LkpAssetTypeOidList: [],
    Location: "",
    Note: "",
    Length: '',
    PrintSpineLabel: false,
    ScriptureReferences: [],
    SeriesName: "",
    Speaker_Artist_Author: "",
    Title: "",
    Topics: [],
    lkpTopicOid: '',
    lkpMediaTypeOid: '',
    lkpAssetCategoryOid: '',
    lkpAssetStatusOid: '',
    lkpEventOid: 7001,
    lkpSeriesOid: '',
    SelectAll:false,
    SelectAudio:false,
    SelectBook:false,
    SelectMusic:false,
    SelectVideo:false
  }

  public newTopic: String = '';
  public confirmNewTopic: String = '';

  public assetTypes = [];
  public currentAsset = '';

  public saving: boolean = false;
  public addingTopic: boolean = false;

  public categoryTypes = [];
  public selectedCategoryTypes = [];
  public seriesTypes = [];
  public topicTypes = [];

  topicOptionsModel: number[];
  topicOptions: IMultiSelectOption[];

  // Settings configuration
  topicSearchSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true
  };

  // Text configuration
  topicSearchTexts: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    searchEmptyResult: 'Nothing found...',
    searchNoRenderText: 'Type in search box to see results...',
    defaultTitle: 'Select',
    allSelected: 'All selected',
  };

  constructor(
    private _restService: RestService, 
    private _lookup: LookupService, 
    private route: ActivatedRoute, 
    private _toast: ToastsManager, 
    private router:Router,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this.assetTypes = this._lookup.findLookupByLookupName('AssetType');
    for (var i = this.assetTypes.length - 1; i >= 0; i--) {
      if (this.assetTypes[i].Value === "Audio") {
        this.assetTypes.splice(i, 1);
      }
      if (this.assetTypes[i].Value === "Video") {
        this.assetTypes[i].Value = 'DVD';
      }
    }
    this.categoryTypes = this._lookup.findLookupByLookupName('AssetCategory');
    this.seriesTypes = this._lookup.findLookupByLookupName('Series');
    this.getTopicOptions();
  }

  @ViewChild('scannerInput') scannerInput;
  @ViewChild('SubmitModal') SubmitModal;
  @ViewChild('notes') notes;

  ngOnInit() {
    
  }

  getTopicOptions() {
    this.topicTypes = this._lookup.findLookupByLookupName('Topic');
    
    for (let topic of this.topicTypes) {
      topic.id = topic.Oid;
      topic.name = topic.Value; 
    }
    this.topicOptions = this.topicTypes.sort((a, b) => a.name.localeCompare(b.name));
  }

  onChange() {
    console.log(this.topicOptionsModel);
  }

  selectAll() {
    console.log(this.media.SelectAll)
    if (!this.media.SelectAll) {
      this.media.SelectAudio = true;
      this.media.SelectMusic = true;
      this.media.SelectBook = true;
      this.media.SelectVideo = true;
    } else {
      this.media.SelectAudio = false;
      this.media.SelectMusic = false;
      this.media.SelectBook = false;
      this.media.SelectVideo = false;
    }
  }

  saveAsset() {
    this.saving = true;
    console.log("save new asset");
    if (this.topicOptionsModel && this.topicOptionsModel.length) {
      for (let option of this.topicOptionsModel) {
        this.media.Topics.push({TopicOid: option, TopicName: ''});
      }
    }
    let url = this.serviceStackUrl + 'Asset-AddEditAsset';
    console.log(this.media);
    this._restService.post(url, { Asset: this.media }).then(response => {
      this.saving = false;
      this.SubmitModal.hide();
      console.log(response);
      if (response.Asset) {
        this._toast.success('Asset added successfully');
        this.router.navigate(['/media/'+ response.Asset.Oid]);
      } else {
        this._toast.error('Failed to save asset');
      }
    })
  }

  Submit() {
    this.SubmitModal.show();
    setTimeout(() => {
      $('#scannerInput').focus();
    }, 500);
  }

  selectAsset(asset) {
    console.log(asset);
    this.currentAsset = asset.Value;
    this.media.LkpAssetTypeOidList=[asset.Oid];
    this.selectedCategoryTypes = this.categoryTypes.filter(category => {
      return category.ParentOid === asset.Oid
    });
  }

  addTopic() {
    this.addingTopic = true;
    if (this.newTopic === this.confirmNewTopic && this.newTopic != '') {
      let url = this.serviceStackUrl + 'Admin-AddNewTopic';
      this._restService.post(url, {TopicName:this.newTopic}).then(response => {
        console.log(response);
        if (response.Success) {
          console.log(response.Lookup);
          let lookups = JSON.parse(localStorage.getItem("lookups"));
          lookups.push(response.Lookup);
          console.log(lookups);
          this._lookup.updateLookups(lookups);
          this.getTopicOptions();
          this._toast.success('Successfully added new topic');
        } else {
          this._toast.error(response.Errors[0].Message);
        }
        this.newTopic = '';
        this.confirmNewTopic = '';
      }).catch((err) => {
        console.log(err);
        this._toast.error('Error adding new topic');
        this.newTopic = '';
        this.confirmNewTopic = '';
      });
    } else if (this.newTopic != this.confirmNewTopic) {
      this._toast.error('New topic name and confirm new topic name do not match');
      this.newTopic = '';
      this.confirmNewTopic = '';
    } else if (this.newTopic === '' || this.confirmNewTopic  === '') {
      this._toast.error('New topic name cannot be empty');
      this.newTopic = '';
      this.confirmNewTopic = '';
    }
    this.addingTopic = false;
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/media-add/media-add.component.ts